import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 34896 34897"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:none}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2283844330720">
        <circle
          cx={17448}
          cy={17449}
          r={16253}
          className="fill-none stroke1"
          style={{
            stroke: "#fefefe",
            strokeWidth: 2390.24,
          }}
        />
        <circle
          cx={17448}
          cy={17449}
          r={13687}
          className="fill-none stroke1"
          style={{
            stroke: "#2b2a29",
            strokeWidth: 2390.24,
          }}
        />
      </g>
      <path
        d="M17175 19015h-4942l8146-11127-2253 7662h4537l-7801 11460z"
        style={{
          fill: "#2b2a29",
          stroke: "#2b2a29",
          strokeWidth: 364.272,
        }}
        className="stroke1 fill"

      />
    </g>
  </svg>
)
export default SvgComponent
